import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'
import { IValidationRule } from 'legacy/lut/helpers/validateRules/checkEmailDomain'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { getTokens } from 'core-components/sitebuilder/helpers/getTokens'
import { selectAppOwnerId } from 'core-components/sitebuilder/store/selectors/selectAppOwnerId'
import { Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'
import Logger from 'core/utils/Logger'
import { PartnerHelper } from 'onboarding/classes/helpers/PartnerHelper'
import { fail } from 'onboarding/classes/services/notification'
import { contactService } from 'onboarding/services/contactService'

export const useValidationRulesAndEmailList = (partnerId: string, countryCode: string) => {
  const appOwnerId = useSelector(selectAppOwnerId)
  const [validationRules, setValidationRules] = useState<IValidationRule[]>([])
  const [emailList, setEmailList] = useState<string[]>([])

  useEffect(() => {
    const fetchValidationRules = async () => {
      if (!countryCode) return

      try {
        const validationRuleSource = CrudStore.get<IValidationRule>(CrudStoreItem.ValidationRules)
        validationRuleSource.setFilter({
          logic: Logic.AND,
          filters: [{ field: 'CountryCode', operator: Operator.EQUAL, value: countryCode }],
        })
        const { items } = await validationRuleSource.fetch()
        setValidationRules(items)
      } catch (error) {
        Logger.error('Error fetching validation rules:', error)
      }
    }

    fetchValidationRules()
  }, [countryCode])

  useEffect(() => {
    const fetchEmailList = async () => {
      if (!partnerId || PartnerHelper.isDummyPartnerRequest(partnerId)) return

      const [accessToken] = getTokens(appOwnerId)
      if (!accessToken) {
        fail('Please, re-log in to the application')
        return
      }

      try {
        const partnerContacts = await contactService.getExistingContactsByPartnerId(
          partnerId,
          accessToken
        )
        setEmailList(
          partnerContacts
            ?.map((contact) => contact.email)
            .filter((email): email is string => Boolean(email)) || []
        )
      } catch (error) {
        Logger.error('Error fetching partner contacts:', error)
      }
    }

    fetchEmailList()
  }, [partnerId, appOwnerId])

  return { validationRules, emailList }
}
